module.exports = __webpack_public_path__ + "static/media/season_draft_ss.c8ecca14.png";